export default "__VITE_ASSET__CA1a3dqH__"